<template>
    <v-dialog v-model="dialog" width="700" :fullscreen="isMobileOrTablet()" persistent>
        <v-card class="rounded-lg" style="display: flex; flex-direction: column; height: 100%;">
            <v-card-title style="background-color: #1a5b0f !important; display: flex; justify-content: space-between; align-items: center;">
                <div>
                    <span class="font-weight-bold text-h6 text-white">{{ dialog_title }}</span>
                    <div class="text-caption text-white">{{ dialog_sub_title }}</div>
                </div>
                <v-btn v-if="loading == false" flat icon color="darkGreen" @click="closeDialog()">
                    <v-icon>mdi-close</v-icon>
                </v-btn>
            </v-card-title>
            <v-divider></v-divider>
            <v-card-text style="overflow-y: auto; max-height: calc(100vh - 100px);">
                <v-form ref="form" class="mt-2">
                    <v-row dense>
                        <v-col cols="12">
                            <v-select
                                v-model="faculty_includes"
                                label="Faculties Include and Section"
                                variant="outlined"
                                rounded="lg"
                                color="darkGreen"
                                chips
                                multiple
                                :items="facultyIncludesData"
                                :item-title="getFacultyName"
                                item-value="id"
                                return-object
                                :rules="[newFormRules.required]"
                                :loading="loading"
                                >
                            </v-select>
                        </v-col>
                    </v-row>
                </v-form>
            </v-card-text>
            <v-divider></v-divider>
            <v-card-actions class="pa-3" style="margin-top: auto;">
                <v-spacer></v-spacer>
                <v-btn class="mr-1" :disabled="loading" text="Cancel" variant="outlined" elevation="1" @click="closeDialog()"></v-btn>
                <v-btn class="mr-1" :loading="loading" text="Save" variant="elevated" elevation="1" color="darkGreen" @click="validateForm()"></v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import axios from 'axios';
import { defineComponent } from 'vue'
import { useSnackbar } from '@/composables/useSnackbar'

export default defineComponent({
     emits: ["refresh"],
     data(){
        return {
            dialog: false,
            dialog_title: null,
            dialog_sub_title: null,
            action: null,
            loading: false,

            facultyIncludesData: [],
            faculty_includes: [],
            complianceData: [],
            compliance: null,
            facultyLoad: null,

            newFormRules: {
                required: (value) => value && value.length > 0 || 'This field is required',
                validFacultyLoad: (value) => {
                    if (!value) return true;
                    return this.facultyLoadData.some((item) => item.id === value.id) || "Invalid selection";
                },
            },
        }
     },
     methods: {
        initUpdate(data){
            this.dialog = true
            this.dialog_title = 'Add Faculties to Tag'
            this.dialog_sub_title = 'Add faculties to be tagged for ' + data.facultyLoad.code + ', ' + data.compliance.compliance_name
            this.action = 'edit'

            this.complianceData = data
            this.compliance = data.compliance
            this.facultyLoad = data.facultyLoad
            this.loadFacultyIncludes()
        },
        async loadFacultyIncludes(){
            this.loading = true
            if(this.faculty_includes && this.faculty_includes.length > 0) { this.faculty_includes = [] }

            if(!this.compliance.is_term_separated){
                let res = await this.axiosCall('/faculty-load/findAllFacultyWithSameLoad/' + this.facultyLoad?.code + '/' + this.$store.state.semester_schoolyear.id + '/' + this.compliance.id, 'get', null, true)
                if(res && res.data){
                    this.loading = false
                    this.facultyIncludesData = res.data
                }
            }
            else{
                let res = await this.axiosCall('/faculty-load/findAllFacultyWithSameLoadAndTerm/' + this.facultyLoad?.code + '/' + this.$store.state.semester_schoolyear.id + '/' + this.complianceData.term_id + '/' + this.compliance.id, 'get', null, true)
                if(res && res.data){
                    this.loading = false
                    this.facultyIncludesData = res.data
                }
            }
        },
        getItemTitle(item) {
            if(this.compliance.is_sorted_course == true){
                return `${item.code} - ${item.title}`;
            }
            else{
                return `${item.code} - ${item.title} (${item.section_code})`;
            }
        },
        getFacultyName(item){
            return `${item.user?.fname} ${item.user?.lname} (${item.section_code})`;
        },
        async validateForm(){
            const { showSnackbar } = useSnackbar()
            const { valid } = await this.$refs.form.validate()

            if(valid){
                this.loading = true
                let formData = {
                    id: this.id,
                    faculty_includes: this.faculty_includes,
                    file_id: this.complianceData.file_id,
                    compliance_id: this.complianceData.compliance_id,
                    term_id: this.complianceData.term_id,
                    semester_schoolyear_id: this.complianceData.semester_schoolyear_id,
                    date_submitted: this.complianceData.date_submitted
                }

                const token = localStorage.getItem('aums-token')
                if(this.action == 'edit'){
                    axios.post(process.env.VUE_APP_SERVER_URL + '/compliance-upload-details/addFacultyTagged', formData,
                    { headers:
                        { 
                            'Authorization': `Bearer ${token}`,
                        }
                    }
                    ).then((res)=>{
                        if(res.data.status == 200){
                            this.loading = false
                            this.$emit('refresh')
                            showSnackbar('Faculty Tagged successfully added!')
                            this.$refs.form.reset()
                            this.dialog = false
                        }
                    }).catch((error)=>{
                        if(error.response.status == 401){
                            this.loading = false
                            showSnackbar('Token expired! Logging out..')

                            localStorage.removeItem("vuex");
                            localStorage.removeItem("aums-token");
                            window.location.reload();
                        }
                        else{
                            console.log(error)
                        }
                    })
                }
            }
        },
        closeDialog(){
            this.$refs.form.reset()
            this.dialog = false
        }
     }
})
</script>

<style scoped>

</style>